module.exports = __webpack_public_path__ + "media/images/hackerrank/software-42f6b168b29092c8c335dd636578a7d6.png";